import React from 'react';
import { LayerGroup, WMSTileLayer, LayersControl } from 'react-leaflet';
import LandUseLegend from '../legends/LandUseLegend.jsx';

const { Overlay, } = LayersControl
const GEOSERVER_LANDCOVER_LAYER_NAME = 'landcover'
const AVAILABLE = true

export class LandCoverLayers {

    static getMapLayers(t) {

        const name = t("map.landCover") + (AVAILABLE ? "" : " (Unavailable)");

        return (
            <Overlay name={name} dataType={t("map.landCover")}>
                <LayerGroup id="landCoverLayer" >
                    <WMSTileLayer
                        url='/maps/geodata/wms'
                        layers={GEOSERVER_LANDCOVER_LAYER_NAME}
                        format='image/png'
                        transparent='true'
                        opacity="0.7"
                    />
                </LayerGroup>
            </Overlay>
        )
    }

    static getLegend(t) {
        return <LandUseLegend layerTitle={t("map.landCover")} legendTrans={t("legendsTool.legend")} />
    }
}